
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const Fire = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="Fire" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M14.72909 7.921a6.27815 6.27815 0 00-.782-1.617 4.55941 4.55941 0 01-.413-.75 4.16623 4.16623 0 01-.218-.625 3.05866 3.05866 0 01-.076-.485 2.32275 2.32275 0 01-.008-.312 1.03445 1.03445 0 00.008-.125.414.414 0 00-.025-.273.538.538 0 00-.176-.219.52306.52306 0 00-.261-.1.54188.54188 0 00-.057 0 .50905.50905 0 00-.22.05.83976.83976 0 00-.136.063 2.79 2.79 0 00-1.2 1.224 2.90124 2.90124 0 00-.109.277 3.12079 3.12079 0 00-.118.3 5.54831 5.54831 0 00-.219 1.047c-.089-.136-.168-.264-.234-.383s-.13-.227-.187-.321a6.71209 6.71209 0 01-.5-1.421c-.006-.028-.009-.05-.015-.078a8.849 8.849 0 01-.195-1.2c0-.022-.006-.047-.008-.068a9.08914 9.08914 0 01-.009-1.18c.023-.4.045-.666.068-.8s.039-.237.05-.32a.439.439 0 00-.151-.468.55991.55991 0 00-.252-.118.6602.6602 0 00-.117-.01.725.725 0 00-.153.017c-.112.032-.255.079-.429.142a5.68563 5.68563 0 00-.875.468 6.75477 6.75477 0 00-1.135.868l-.018.021a4.57526 4.57526 0 00-.52.6 5.86362 5.86362 0 00-.5.768c-.038.068-.061.142-.1.21a6.66315 6.66315 0 00-.632 1.765 7.962 7.962 0 00-.068 2.792.714.714 0 00.022.11c.043.269.092.539.161.811a3.22088 3.22088 0 01-.511-.419c-.03-.032-.059-.076-.089-.11a3.22987 3.22987 0 01-.336-.419 6.33205 6.33205 0 01-.774-1.812.437.437 0 00-.159-.242.52994.52994 0 00-.3-.117.72716.72716 0 00-.093-.007.469.469 0 00-.25.066.463.463 0 00-.178.191 3.1812 3.1812 0 00-.169.273c-.067.119-.173.332-.312.64s-.266.614-.378.914a5.25184 5.25184 0 00-.371 1.861 5.267 5.267 0 00.316 1.874 6.97285 6.97285 0 00.481 1.074c.01.017.015.036.024.053.048.086.114.16.166.243a6.89533 6.89533 0 00.456.672c.085.108.181.2.272.308a7.20048 7.20048 0 00.516.532c.045.041.081.09.127.13.069.06.151.1.222.161a6.85573 6.85573 0 00.565.407c.135.088.271.171.412.25.2.109.4.2.609.294.1.042.189.1.29.14.082.031.166.053.249.081.048.017.1.032.145.048a7.1164 7.1164 0 00.933.224c.047.008.1.012.142.019a6.83912 6.83912 0 003.543-.393 7.2771 7.2771 0 003.222-2.549 5.916 5.916 0 001.037-5.047zm-7.754 6.993c-.085-.014-.169-.032-.253-.05a5.89992 5.89992 0 01-.753-.206c-.059-.021-.121-.037-.18-.06a5.91246 5.91246 0 01-.865-.413c-.049-.029-.1-.063-.144-.093a6.05353 6.05353 0 01-.678-.488c-.053-.044-.107-.087-.159-.133a6.05812 6.05812 0 01-.5-.5c-.031-.034-.064-.066-.094-.1a5.95428 5.95428 0 01-.516-.7 5.15292 5.15292 0 01-.8-2.414 4.44709 4.44709 0 01.279-1.857c.085-.23.185-.474.3-.725a5.77991 5.77991 0 00.545 1.034 4.2294 4.2294 0 00.57.694 3.62117 3.62117 0 00.675.55l2.1 1.3-.606-2.393a7.87414 7.87414 0 01-.241-1.659 7.24947 7.24947 0 01.1-1.387c.012-.075.017-.151.032-.225a5.655 5.655 0 01.62-1.683 6.99784 6.99784 0 01.421-.655c.082-.109.174-.209.265-.311.056-.061.113-.141.167-.192a5.87789 5.87789 0 01.97-.742c.151-.092.27-.161.365-.214-.008.106-.017.233-.026.387a10.41318 10.41318 0 00.011 1.31c.011.134.032.266.049.4.013.105.02.2.038.314.041.264.091.526.153.786a7.62067 7.62067 0 00.573 1.634l.018.038.022.037c.055.09.117.2.175.3.078.14.169.288.269.44l1.509 2.286.32-2.72v-.022a4.44716 4.44716 0 01.169-.816l.005-.019a2.51469 2.51469 0 01.166-.424 2.08905 2.08905 0 01.155-.24c.025-.036.045-.079.072-.112.016.1.037.206.061.306l.007.02a4.98442 4.98442 0 00.257.743l.008.024a5.34509 5.34509 0 00.258.469c.081.147.145.3.241.441a7.10124 7.10124 0 01.394.692 5.23556 5.23556 0 01.215.532c.013.038.037.083.047.119a3.87011 3.87011 0 01.171.99 5.85 5.85 0 01-3.761 5.346 5.84418 5.84418 0 01-2.236.447 6.02084 6.02084 0 01-.96-.086z" />
</svg>
    </HvIconBase>
)};

Fire.propTypes = HvIconBase.propTypes;

export default Fire;